import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { masterDataInitialState } from "./intialState";
import { MasterDataResponse } from "@/types/api-response";


const masterDataSlice = createSlice({
    name: "masterData",
    initialState: () => {
        const initialState = { ...masterDataInitialState }
        return initialState
    },
    reducers: {
      fetchDataSuccess: (state, action: PayloadAction<MasterDataResponse>) => {
        return { ...state, ...action.payload };
    },
}});

export const {
  fetchDataSuccess
} = masterDataSlice.actions;

export default masterDataSlice;
